import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { withRouter } from 'react-router';

import ChangePasswordComponent from '../components/login/resetPassword/ChangePasswordComponent';
import SIGN_UP_RULES from '../validation/validationRules/signUp';
import { SIGN_IN_PATH, INVITE_PATH, OLD_INVITE_PATH, CHANGE_PASSWORD_PATH } from '../constants/routes';
import { getValidationRules } from '../validation/validation';
import { checkLinkTokenAction, changePasswordAction, completeInvitationAction } from '../store/actions/session';

const mapStateToProps = ({ session: { isLoading } }, { history, location }) => ({
    isLoading,
    location,
    history,
});

const mapDispatchToProps = {
    checkLinkTokenAction,
    changePasswordAction,
    completeInvitationAction,
};

const mergeProps = (
    { history, location: { search, pathname }, isLoading },
    { checkLinkTokenAction, changePasswordAction, completeInvitationAction }
) => {
    const matchedResult = search.match(/token=([^&]+)/);
    const token = matchedResult && matchedResult[1];
    const companyId = pathname.split('/')[1];
    return {
        isLoading,
        old: pathname.includes(OLD_INVITE_PATH),
        onCancel: () => history.push(SIGN_IN_PATH),
        onSubmit: ({ password }) => {
            if (pathname.includes(OLD_INVITE_PATH)) {
                return completeInvitationAction({ password, token, old: true, companyId: companyId })
            } else if (pathname.includes(INVITE_PATH)) {
                return completeInvitationAction({ password, token, old: false, companyId: companyId });
            } else {
                return changePasswordAction({ password, token });
            }
        },
        checkLinkToken: () => checkLinkTokenAction(token, pathname),
        isChangePasswordAction: pathname === CHANGE_PASSWORD_PATH,
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(reduxForm({
    form: 'changePassword',
    validate: getValidationRules(['password', 'confirmPassword', 'acceptTerms', 'acceptSubscription'], {
        password: SIGN_UP_RULES.password,
        confirmPassword: SIGN_UP_RULES.confirmPassword,
        acceptTerms: SIGN_UP_RULES.acceptTerms,
        acceptSubscription: SIGN_UP_RULES.acceptSubscription,
    }),
})(ChangePasswordComponent)));



// WEBPACK FOOTER //
// ./src/containers/ChangePasswordContainer.js